import { createAsyncThunk } from "@reduxjs/toolkit";
import { createInvoice as createInvoiceApi,
    getInvoicesList as getInvoicesListApi,
    retryInvoiceApi,
} from "./api";
import { toast } from "react-toastify";

export const createInvoice = createAsyncThunk(
  "invoicing/createInvoice",
  async (invoice: any) => {
    try {
      const response: any = await createInvoiceApi(invoice);

      // El backend puede responder 200 con { success: false, message: "Unauthorized" }
      // Solo mostramos éxito cuando success === true
      if (response && response.success) {
        toast.success(response.message || "Factura creada con éxito", { autoClose: 3000 });
        return response;
      }

      // Forzar error para que caiga en el rejected y no muestre éxito falso
      const message = (response && response.message) ? response.message : "Error al crear la factura";
      throw new Error(message);
    } catch (error) {
      const msg = typeof error === "string" ? error : (error as any)?.message || "Error al crear la factura";
      toast.error(msg, { autoClose: 3000 });
      throw error;
    }
  }
);

export const getInvoicesList = createAsyncThunk(
  "invoicing/getInvoicesList",
  async (params: any) => {
    try {
      const response = await getInvoicesListApi(params);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const retryInvoice = createAsyncThunk(
  "invoicing/retryInvoice",
  async (data: { progressJobId: string; progressStatus: string }, { rejectWithValue }) => {
    try {
      const response: any = await retryInvoiceApi(data);

      // Esperamos un payload: { success, message, state }
      if (response?.success) {
        const msg = response?.message || "Factura encolada correctamente";
        toast.success(msg, { autoClose: 3000 });
      } else {
        const msg = response?.message || "Error técnico al encolar";
        toast.error(msg, { autoClose: 4000 });
      }

      return response;
    } catch (error: any) {
      const msg = typeof error === "string" ? error : error?.message || "Error al enviar reintento";
      toast.error(msg, { autoClose: 4000 });
      return rejectWithValue(error);
    }
  }
);
